import API_CLIENT from "../../utils/Api";
import { buildPayload } from "../../utils/helper";

export function GeneratePresignedUrl(payload) {
  const sanitizedPayload = buildPayload(payload);
  return API_CLIENT.post("/media/generate-upload-url", sanitizedPayload);
}

export function UploadFile({ url, file }) {
  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });
}
